import styled from "@emotion/styled";

const Content = styled.div`
  margin-top: 24px;
`;
export { Content };
